import React from 'react';

interface LanguageSelectorProps {
  language: 'fr' | 'en';
  onLanguageChange: (language: 'fr' | 'en') => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ language, onLanguageChange }) => {
  return (
    <div className="flex items-center space-x-1">
      <button
        onClick={() => onLanguageChange('fr')}
        className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
          language === 'fr'
            ? 'bg-primary text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        FR
      </button>
      <button
        onClick={() => onLanguageChange('en')}
        className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
          language === 'en'
            ? 'bg-primary text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSelector;
